// src/components/Verificar2FA.js

import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { verificarCodigo2FA } from "../services/authService";
import { obtenerFuncionesPorEmail } from "../services/permisosService";
import { BITSET_LEN } from "../constants/permisos";

// ===== Helpers =====
const sanitize = (s = "") => {
  const padded = (s || "").toString().padEnd(BITSET_LEN, "0").slice(0, BITSET_LEN);
  // fuerza bit #1 (INICIO_VIEW) a 1 para evitar bloqueos
  return "1" + padded.slice(1);
};
const MIN_BITSET = "1".padEnd(BITSET_LEN, "0");

export default function Verificar2FA() {
  const [codigo, setCodigo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [cargando, setCargando] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // correo desde estado o localStorage
  const email = location.state?.email || localStorage.getItem("email") || "";

  // si no hay email, regresar al inicio
  useEffect(() => {
    if (!email) navigate("/", { replace: true });
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setMensaje("");

    try {
      // 1) Verificar código (guarda token/email en localStorage dentro de authService)
      const { token, email: emailSrv, endpoint: epFromLogin } = await verificarCodigo2FA(
        email,
        codigo
      );

      // 2) Intentar obtener bitset/funciones (unificado) -> solo para almacenarlo;
      //    la navegación SIEMPRE será /dashboard/admin
      let bitString = sanitize(epFromLogin || "");
      try {
        const perms = await obtenerFuncionesPorEmail(emailSrv || email, token);
        if (perms?.bitset) bitString = sanitize(perms.bitset);
      } catch (ePerms) {
        // si falla, usar mínimo
        bitString = sanitize(MIN_BITSET);
        console.warn("No se pudieron obtener permisos; usando mínimo.", ePerms);
      }

      // 3) Persistir bitset y notificar a los providers
      localStorage.setItem("endpoint", bitString);
      window.dispatchEvent(new Event("auth-changed")); // <-- importante

      // 4) Navegar SIEMPRE al dashboard admin
      setMensaje("✅ Verificación exitosa");
      navigate("/dashboard/admin", { replace: true });
    } catch (error) {
      setMensaje(error?.message || "Código incorrecto");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900 text-white">
      <h2 className="text-2xl mb-4">Verificación en dos pasos</h2>

      <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-4">
        <input
          type="text"
          placeholder="Código de autenticación"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          className="p-2 rounded border border-gray-400 text-black"
          required
        />
        <button
          type="submit"
          disabled={cargando}
          className={`px-4 py-2 rounded text-white ${
            cargando ? "bg-gray-600" : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {cargando ? "Verificando..." : "Verificar"}
        </button>

        {mensaje && <p className="text-red-400">{mensaje}</p>}
      </form>
    </div>
  );
}
